import * as tslib_1 from "tslib";
import { NgZone } from "@angular/core";
import { BaseComponent } from "../base/base.component";
import { AppComponent } from "../app.component";
import { Location } from "@angular/common";
import { AlertUtils } from "../../crossconcern/utilities/utils/alert.utils";
import { NurseryManager } from "../../business/managers/nursery.manager";
import { concatMap, finalize, map } from "rxjs/operators";
import { UserManager } from "../../business/managers/user.manager";
import { GenericService } from "../../crossconcern/services/generic.services";
import { MapsAPILoader } from "@agm/core";
import { Router } from "@angular/router";
import { CLICK_EVENT, MAP_INITIAL_LATITUDE, MAP_INITIAL_LONGITUDE } from "../../crossconcern/utilities/properties/map.properties";
import { MAP_ROUTE } from "../../crossconcern/utilities/properties/routename.property";
import { DIM_BREAKPOINT_DESKTOP_WIDTH } from "../../crossconcern/utilities/properties/base.property";
import { PhotosphereManager } from "../../business/managers/photosphere.manager";
import { forkJoin } from "rxjs/internal/observable/forkJoin";
var NurseriesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseriesComponent, _super);
    function NurseriesComponent(appComponent, router, location, genericService, mapsAPILoader, nurseryManager, photosphereManager, userManager, zone, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.mapsAPILoader = mapsAPILoader;
        _this.nurseryManager = nurseryManager;
        _this.photosphereManager = photosphereManager;
        _this.userManager = userManager;
        _this.zone = zone;
        _this.alertUtils = alertUtils;
        _this.avgLat = MAP_INITIAL_LATITUDE;
        _this.avgLong = MAP_INITIAL_LONGITUDE;
        _this.zoom = 7;
        _this.isSidebarOpen = true;
        _this.sidebarMode = "push";
        _this.nurseries = [];
        _this.tmpPromotions = [];
        _this.promotions = [];
        return _this;
    }
    NurseriesComponent.prototype.ngOnInit = function () {
        this.appComponent.startLoading();
        this.isSidebarOpen = window.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH;
    };
    NurseriesComponent.prototype.initDrawManager = function (googleMap) {
        var _this = this;
        this.mapsAPILoader.load().then(function () {
            _this.NURSERY_MARKER = {
                url: "/assets/img/ic_nursery_marker.png",
                scaledSize: new google.maps.Size(40, 60)
            };
            _this.googleMap = googleMap;
            _this.getNurseries();
            _this.getFeaturedPromotions();
        });
    };
    NurseriesComponent.prototype.getNurseries = function () {
        var _this = this;
        this.nurseryManager.getNurseries(true, 10000, 0)
            .pipe(map(function (_a) {
            var _ = _a[0], nurseries = _a[1];
            nurseries.forEach(function (nursery) {
                _this.imageExists("/assets/img/slider/" + nursery.uuid + ".jpg", function (res) {
                    if (res) {
                        nursery.imageURL = "/assets/img/slider/" + nursery.uuid + ".jpg";
                    }
                    else {
                        nursery.imageURL = null;
                    }
                });
            });
            return nurseries;
        }), finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (list) {
            _this.nurseries = list;
            _this.addMarkers();
        });
    };
    NurseriesComponent.prototype.addMarkers = function () {
        var _this = this;
        if (this.nurseries) {
            var _loop_1 = function (nursery) {
                if (nursery.latitude && nursery.longitude) {
                    var content = "<div>" +
                        "<h6>" + nursery.name + "</h6>" +
                        "</div>";
                    var infoWindow_1 = new google.maps.InfoWindow({
                        position: new google.maps.LatLng(nursery.latitude, nursery.longitude),
                        content: content,
                        pixelOffset: new google.maps.Size(0, -60)
                    });
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(nursery.latitude, nursery.longitude),
                        icon: this_1.NURSERY_MARKER
                    });
                    marker.setMap(this_1.googleMap);
                    google.maps.event.addListener(marker, CLICK_EVENT, function () {
                        _this.goToRouteByName(MAP_ROUTE, { id: nursery.uuid });
                    });
                    google.maps.event.addListener(marker, "mouseover", function () {
                        infoWindow_1.open(_this.googleMap);
                    });
                    google.maps.event.addListener(marker, "mouseout", function () {
                        infoWindow_1.close();
                    });
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.nurseries; _i < _a.length; _i++) {
                var nursery = _a[_i];
                _loop_1(nursery);
            }
        }
    };
    NurseriesComponent.prototype.imageExists = function (url, callback) {
        var img = new Image();
        img.onload = function () {
            callback(true);
        };
        img.onerror = function () {
            callback(false);
        };
        img.src = url;
    };
    NurseriesComponent.prototype.getFeaturedPromotions = function () {
        var _this = this;
        this.photosphereManager.getPromotions(10000, 0, null, true)
            .pipe(concatMap(function (promotionList) {
            _this.tmpPromotions = promotionList.promotions;
            var promotionsMediaList = [];
            _this.tmpPromotions.forEach(function (promotion) {
                promotionsMediaList.push(_this.photosphereManager.getPromotionMedia(promotion.uuid));
            });
            return forkJoin.apply(void 0, promotionsMediaList);
        }), finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (medias) {
            medias.forEach(function (media, index) {
                if (media.medias && media.medias.length > 0) {
                    var mediaURL = media.medias[0].getMediaURL("view_fhd");
                    if (mediaURL) {
                        _this.tmpPromotions[index].mediaURL = mediaURL.replace("{?res}", "");
                    }
                }
            });
            _this.promotions = _this.tmpPromotions;
        });
    };
    // Sidebar
    NurseriesComponent.prototype.toggleSidebar = function () {
        this.isSidebarOpen = !this.isSidebarOpen;
    };
    NurseriesComponent.prototype.refreshSidebar = function () {
        var _this = this;
        setTimeout(function () {
            _this.sidebarElement.triggerRerender();
        }, 900);
    };
    return NurseriesComponent;
}(BaseComponent));
export { NurseriesComponent };
